import { render, staticRenderFns } from "./ScrollButton.vue?vue&type=template&id=44a47554&scoped=true&lang=pug&"
import script from "./ScrollButton.vue?vue&type=script&lang=js&"
export * from "./ScrollButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a47554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a47554')) {
      api.createRecord('44a47554', component.options)
    } else {
      api.reload('44a47554', component.options)
    }
    module.hot.accept("./ScrollButton.vue?vue&type=template&id=44a47554&scoped=true&lang=pug&", function () {
      api.rerender('44a47554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/ScrollButton.vue"
export default component.exports